import Layouts from '../../layouts/Layouts';
import BannerWithSearchBar from '../../Components/banners/bannerWithSearchBar/BannerWithSearchBar';
import { FindDoctorByDiseaseFilter } from '../../Components/Forms';
import './findADoctorViewAllSpecailist.css';

function FindADoctorViewAllSpecailist() {
  return (
    <Layouts>
      <section className="findADoctorViewAllSpecailist">
        <BannerWithSearchBar />
        <FindDoctorByDiseaseFilter />
      </section>
    </Layouts>
  );
}

export default FindADoctorViewAllSpecailist;
